export function HowItWorks(){
    return(
        <div>
            This is How It Works
        </div>
    )
}